import qs from 'qs';

// Stores UTM parameters in local storage if it exists
export const UserContextProvider = props => {
  const URL = window.location.search;

  if (URL) {
    const params = qs.parse(URL, { ignoreQueryPrefix: true });

    if ('utm_campaign' in params) {
      // Convert URL Parameters to an object string
      const utm = {
        name: params.utm_campaign,
        medium: params.utm_medium,
        source: params.utm_source,
      };

      try {
        sessionStorage.setItem('om_utm_meta', JSON.stringify(utm));
      } catch (e) {
        /* eslint-disable no-console */
        console.error('Unable to store campaign in session storage', e);
      }
    }
  }

  return props.children;
};

export default UserContextProvider;
